import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";
import { EntityOnelineMenu } from "scmp-app/components/entity-oneline-menu";
import { MenuItem } from "scmp-app/components/entity-oneline-menu/styles";

export const Container = styled.div`
  inline-size: 100%;
  padding-block-start: 12px;
  border-block-start: 1px #000000 solid;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 24px;
    align-items: center;
  }
`;

export const TitleLink = styled(EntityLink)`
  flex-shrink: 0;

  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  white-space: nowrap;
  text-transform: uppercase;
`;

export const KeyIndustries = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  min-inline-size: 0;
`;

export const KeyIndustriesLabel = styled.span`
  flex-shrink: 0;

  color: #333333;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  font-style: italic;
  white-space: nowrap;
`;

export const StyledEntityOnelineMenu = styled(EntityOnelineMenu)`
  min-inline-size: 0;

  ${MenuItem} {
    font-family: ${fontRobotoCondensed};
  }
`;
